import environment from 'environment';
import HttpErrorResponseModel from '../../models/HttpErrorResponseModel';
import EffectUtility from '../../utilities/EffectUtility';
import TransferModel from './models/TransferModel';
import OperationModel from './models/OperationModel';

export default class ChallengeEffect {
    public static async requestDoTransferFx(params?: any): Promise<TransferModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.doTransferFx;
        return EffectUtility.getToModel<TransferModel>(TransferModel, endpoint, params);
    }

    public static async requestDoOperationFx(params?: any): Promise<OperationModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.doOperationFx;
        return EffectUtility.getToModel<OperationModel>(OperationModel, endpoint, params);
    }
}
